
<app-admin-side-bar></app-admin-side-bar>

  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-dark">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" appRemoveOverlayDirective data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a class="nav-link">Home</a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a class="nav-link">Balance Histories</a>
      </li>
    </ul>
  
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- <li class="nav-item dropdown">
        <a><app-admin-test-mode></app-admin-test-mode> </a>
      </li> -->
    </ul>
  </nav>
  <!-- /.navbar -->
<!-- /.navbar -->

<div class="content-wrapper">

  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Balance Histories</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a>Home</a></li>
            <li class="breadcrumb-item active">Balance Histories</li>
          </ol>
        </div>
      </div>
    </div><!-- /.container-fluid -->
  </section>

  <div class="container-fluid" style="padding: 15px;">
    <div class="row">
      <section *ngIf="Role==1" class="col-md-12">
        <button class="btnDef" (click)="openCreateModal()">Add New</button> &nbsp;&nbsp;
        <button class="btnDef" (click)="exportData()">Export CSV</button> &nbsp;&nbsp;
        <button class="btnDef" (click)="exportDataPDF()">Export PDF</button>

      </section>
    </div>
    <br>
    <div class="row">
      <!-- <section *ngIf="Role==1" class="col-md-3">
                <button type="button" (click)="openCreateModal()" class="btn btn-primary">
                    Add New
                </button>

            </section> -->
            <div class="col-md-2 col-sm-3">
              <select class="form-control" (change)="onSelectChange($event.target)">
                <option>Select</option>
                <option value="1">Today</option>
                <option value="2">Yesterday</option>
                <option value="3">This week</option>
                <option value="4">Last Week</option>
                <option value="5">This Month</option>
                <option value="6">Last Month</option>
                <option value="7">Custom</option>
              </select>
            </div>
      
            <div class="col-md-3 col-sm-5" *ngIf="boolCustom">
              <mat-form-field style="height: 50px;" class="example-full-width mb-3">
                <mat-date-range-input style="margin-top: -12px;" [rangePicker]="picker">
                  <input style="position: absolute; top:0px" matStartDate placeholder="Start Date & Time" [(ngModel)]="startDate">
                  <input matEndDate placeholder="End Date & Time" [(ngModel)]="endDate">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
            </div>
            <div *ngIf="Role==1"   class="col-md-3 pull-right">
              <mat-form-field  class="date-range-picker" style="height: 50px; " appearance="fill">
                <mat-select (selectionChange)="filterRetailers($event)" style="position: absolute; top:0px" #retailerSelect [placeholder]="'Select Retailer'">
                  <mat-option [value]="0">Select All</mat-option>
                  <mat-option *ngFor="let retailer of Retailers" [value]="retailer.id">
                    {{ retailer.fullName }}
                  </mat-option>
                </mat-select>
                <button style="width: 10% !important; border: 0px;" mat-button matSuffix (click)="retailerSelect.open()">
                </button>
              </mat-form-field>
            </div>
            <section class="col-md-2 col-sm-3" style="float: right;">
              <div class="form-group d-flex align-items-center mx-2">
                  <label for="filter" class="mr-2 mb-0">Filter:</label>
                  <input type="text" class="form-control" id="filter" #keyword placeholder="Search">
              </div>
          </section>
      <section class="col-md-1 mx-2 col-sm-3">
        <button class="btnDef" (click)="Filter(keyword.value)">Search</button>
      </section>
      <section class="col-md-12 mt-2">
        <div class="card">
          <!-- /.card-header -->
          <div class="card-body">
            <div class="row">
              <div class="col-5"></div>
              <div class="col-2">
                <div *ngIf="loader==true">
                  <app-loader style="text-align: center;"></app-loader>
                </div>
              </div>
              <div class="col-5"></div>
            </div>

            <table *ngIf="loader==false" id="example2" class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Retailer</th>
                  <th>Date</th>
                  <th>Transaction Type</th>
                  <th>Old Balance</th>
                  <th>New Balance</th>
                  <th>Payment Applied</th>
                  <!-- <th>Remark</th> -->
                </tr>
              </thead>
              <tbody *ngFor="let item of balanceHistories; let i = index;">
                <tr>
                  <td>{{item.retailerName}}</td>
                  <td>{{item.creationTime}}</td>
                  <td>{{item.transactionType}}</td>
                  <td>{{item.oldBalance}}</td>
                  <td>{{item.newBalance}}</td>
                  <td>{{item.amount}}</td>
                  <!-- <td>{{item.remarks}}</td> -->

                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-center my-3" *ngIf="totalItems > 0">
            <app-pager [totalCount]="totalItems" [pageSize]="100" (pageChanged)="onPageChanged($event)"></app-pager>
          </div>

          <!-- /.card-body -->
        </div>

      </section>
    </div>
  </div>


</div>

 


